import React from "react"
import { Row, Col, Form } from "react-bootstrap"
import { Field, getIn } from "formik"
import DateField from "./date-field-claim-detail"
import FormLabel from "./formLabel"

function FormDatePickerTextBox(props) {
  const { textDesc, form, field, formName, disableBefore, disableAfter, asterisk, allowFutureDate } = props

  const errorsMsg = getIn(form.errors, field.name)
  // const touched = getIn(form.touched, field.name)
  // const formIsValid = props.formIsValid
  // const formClickedNext = props.formClickedNext

  const inputErrorClassName = (touched, errors, inputName) => {
    //  (clickedNext && errors[inputName]) ||
    return errors[inputName] && touched[inputName] ? "is-invalid" : null
  }

  const inputErrorMessage = (touched, errors, inputName) => {
    //return (clickedNext && errors[inputName]) ||
    return errors[inputName] && touched[inputName] ? (
      <span className="InputError">{errorsMsg}</span>
    ) : null
  }
  let showAsterisk = false
  if(asterisk !== undefined){ showAsterisk = true }

  return (
    <Form.Group>
      <Row>
        <FormLabel text={textDesc} asterisk={showAsterisk}/>
        <Col xs={12} md={6} className="marginTop10px">
          <Field
            className={
              "inputbox " +
              inputErrorClassName(form.touched, form.errors, field.name)
            }
            name={field.name}
            inputProps={{
              classNames: inputErrorClassName(
                form.touched,
                form.errors,
                field.name
              ),
            }}
            placeholder="DD/MM/YYYY"
            component={DateField}
            autoComplete="new-password"
            value={field.value || ""}
            formName={formName}
            disableBefore={disableBefore}
            disableAfter={disableAfter}
            allowFutureDate={allowFutureDate}
          />
          {/* {errors && touched && <span className="InputError">{errorsMsg}</span>} */}
          {/* <span className="InputError">{errorsMsg}</span> */}

          {inputErrorMessage(form.touched, form.errors, field.name)}
        </Col>
      </Row>
    </Form.Group>
  )
}
export default FormDatePickerTextBox
